<template>
  <div class="personal-warp">
    <Card>
      <span slot="title">个人资料</span>
      <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getUserInfo)">刷新</el-button>
      <div slot="content" class="userwrap">
        <!-- 个人信息 -->
        <div class="userinfo" v-loading="loading">
          <img :src="userForm.avatar" width="100" height="100">
          <el-row>
            <span>用户姓名：</span>
            <div>{{ userForm.nickName }}</div>
          </el-row>
          <el-row>
            <span>用户性别：</span>
            <div>{{ userForm.sex == 0 ? '男' : '女' }}</div>
          </el-row>
          <el-row>
            <span>电话号码：</span>
            <div>{{ userForm.phonenumber }}</div>
          </el-row>
          <el-row>
            <span>权限角色：</span>
            <div><el-tag v-for="item in userForm.roles" :key="item.roleId" type="success" effect="dark">{{ item.roleName
            }}</el-tag></div>
          </el-row>
          <el-row>
            <span>所属医馆：</span>
            <div><el-tag v-for="item in userForm.deptNames" :key="item" effect="dark">{{ item }}</el-tag></div>
          </el-row>
          <el-row>
            <span>用户类型：</span>
            <div>{{ userForm.typeName }}</div>
          </el-row>
          <div v-if="userForm.type == 0">
            <el-row>
              <span>医生职称：</span>
              <div>{{ doctorForm.doctorTitle }}</div>
            </el-row>
            <el-row>
              <span>医生编码：</span>
              <div>{{ doctorForm.doctorCode }}</div>
            </el-row>
            <el-row>
              <span>荣誉称号：</span>
              <div>
                <el-tag v-if="doctorForm.titleName" type="warning" effect="dark">{{ doctorForm.titleName }}</el-tag>
                <div v-else>-</div>
              </div>
            </el-row>
            <el-row>
              <span>公众查询：</span>
              <div>{{ doctorForm.appStatus == 0 ? '公众号可查询' : '公众号不可查询' }}</div>
            </el-row>
            <el-row>
              <span>医生简介：</span>
              <div v-html="doctorForm.introductionStr"></div>
            </el-row>
            <el-row>
              <span>擅长内容：</span>
              <div v-html="doctorForm.goodAtStr"></div>
            </el-row>
            <el-row>
              <span>执业照片：</span>
              <div><img :src="doctorForm.doctorImgAddr" width="400"></div>
            </el-row>
          </div>
          <el-button type="primary" @click="userEdit">修改资料</el-button>
        </div>
        <!-- 编辑个人信息 -->
        <el-dialog class="userEdit" title="修改个人资料" :visible.sync="dialogVisible" width="720px"
          :before-close="done => $handleClose(done, 'userEditForm')" :close-on-click-modal="false">
          <el-form :model="userEditForm" ref="userEditForm" :rules="userEditFormRules" label-width="80px" inline>
            <el-form-item label="用户姓名" prop="nickName">
              <el-input v-model="userEditForm.nickName" placeholder="请输入用户姓名"
                @input="doctorEditForm.doctorName = userEditForm.nickName" />
            </el-form-item>
            <el-form-item label="电话号码" prop="phonenumber">
              <el-input v-model="userEditForm.phonenumber" disabled />
            </el-form-item>
            <el-form-item label="所属医馆">
              <el-select v-model="userEditForm.deptIds" multiple disabled>
                <el-option v-for="item in deptsOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="用户角色">
              <el-select v-model="userEditForm.roleIds" multiple disabled>
                <el-option v-for="item in rolesOptions" :key="item.value" :label="item.roleName" :value="item.roleId" />
              </el-select>
            </el-form-item>
            <el-form-item label="用户头像">
              <div v-if="userEditForm.avatar">
                <img :src="userEditForm.avatar" class="img" />
                <el-button icon="el-icon-edit" type="primary" @click="editImg('avatar')" class="btn">修改图片</el-button>
              </div>
              <el-upload v-else :on-success="handleImgSuccess2" :action="action" list-type="picture-card"
                :data="{ storagePath: 'picture' }" name="uploadFile">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="用户性别" prop="sex">
              <el-radio-group v-model="userEditForm.sex">
                <el-radio :label="'0'">男</el-radio>
                <el-radio :label="'1'">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="用户类型" prop="type" class="w500">
              <el-radio-group v-model="userEditForm.type" disabled>
                <el-radio v-for="item in typeOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <el-form :model="doctorEditForm" ref="doctorEditForm" label-width="80px" :rules="doctorEditFormRules" inline
            v-if="userEditForm.type == 0">
            <el-form-item label="医生姓名" prop="doctorName">
              <el-input v-model="doctorEditForm.doctorName" placeholder="请输入医生姓名"
                @input="userEditForm.doctorName = doctorEditForm.nickName" />
            </el-form-item>
            <el-form-item label="公众查询" prop="appStatus">
              <el-radio-group v-model="doctorEditForm.appStatus" disabled>
                <el-radio :label="'0'">可查询</el-radio>
                <el-radio :label="'1'">不可查询</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="医生职称">
              <el-input v-model="doctorEditForm.doctorTitle" disabled />
            </el-form-item>
            <el-form-item label="医生编码">
              <el-input v-model="doctorEditForm.doctorCode" />
            </el-form-item>
            <el-form-item label="荣誉称号">
              <el-select v-model="doctorEditForm.titleId" disabled>
                <el-option v-for="item in titlesOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="擅长内容" prop="goodAt">
              <el-input type="textarea" v-model="doctorEditForm.goodAt" :autosize="{ minRows: 2, maxRows: 6 }"
                resize="none" />
            </el-form-item>
              <el-form-item label="医生简介" prop="introduction">
                <el-input type="textarea" v-model="doctorEditForm.introduction" :autosize="{ minRows: 2, maxRows: 6 }"
                  resize="none" />
              </el-form-item>
            <el-form-item label="执业照片" prop="doctorImgAddr">
              <div v-if="doctorEditForm.doctorImgAddr">
                <img :src="doctorEditForm.doctorImgAddr" class="img" />
                <el-button icon="el-icon-edit" type="primary" class="btn"
                  @click="editImg('doctorImgAddr')">修改图片</el-button>
              </div>
              <el-upload v-else :on-success="handleImgSuccess1" name="uploadFile" :action="action"
                list-type="picture-card" :data="{ storagePath: 'picture' }">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="editSave">保存修改</el-button>
            <el-button @click="cancel">取 消</el-button>
          </span>
        </el-dialog>
      </div>
    </Card>
  </div>
</template>

<script lang="js">
import { userEdit, userInfo } from "@/api/user"; // 用户请求
import { titleList } from "@/api/title"; // 称号请求
import { validateName } from "@/utils/regexp" // 自定义验证
import { isNull } from '@/utils/validateBase'
import { imgArr } from "@/assets/images/img";
export default {
  name: "UserInfo",
  data() {
    return {
      imgArr: imgArr,
      loading: true, // 加载
      userForm: {}, // 用户信息
      userEditForm: {}, // 修改信息
      doctorEditForm: {}, // 医生修改信息
      titlesOptions: [], // 称号列表
      deptsOptions: this.$session.get('options'), // 医馆列表
      rolesOptions: this.$session.get('user').roles, // 权限列表
      doctorForm: {}, // 医生信息
      typeOptions: this.$userType, // 用户类型
      dialogVisible: false,
      userEditFormRules: {
        nickName: [{ required: true, validator: validateName, trigger: 'change' }],
        phonenumber: [{ required: true, message: '用户姓名不能为空', trigger: 'blur' }],
        sex: [{ required: true, message: '用户性别不能为空', trigger: 'change' }],
      }, // 用户信息验证规则
      doctorEditFormRules: {
        doctorName: [{ required: true, validator: validateName, trigger: 'change' }],
        doctorTitle: [{ required: true, message: "请选择医生职称", trigger: 'change' }],
        doctorImgAddr: [{ required: true, message: "请上传医生执业照片", trigger: 'blur' }],
        introduction: [{ required: true, message: "医生简介不能为空！", trigger: "blur" }],
        goodAt: [{ required: true, message: "医生擅长不能为空！", trigger: "blur" }]
      }, // 医生信息验证规则
      action: this.$baseUrl + '/file/upload',
      searchForm: {}
    };
  },
  created() {
    this.getTitlesData(); // 请求称号列表
  },
  methods: {
    // 获取用户信息
    async getUserInfo() {
      let { code, data } = await userInfo(this.$session.get('user').userId);
      if (code == 200) {
        this.userForm = data.data;
        data.data.hospDoctorInfo.goodAtStr = ('<p>' + data.data.hospDoctorInfo.goodAt + '</p>').replace('\n', '</p><p>');
        data.data.hospDoctorInfo.introductionStr = ('<p>' + data.data.hospDoctorInfo.introduction + '</p>').replace('\n', '</p><p>');
        this.doctorForm = data.data.hospDoctorInfo;
        this.userForm.roleIds = data.roleIds;
        this.userForm.deptIds = data.deptIds;
        this.userForm.deptNames = [];
        this.userForm.avatar == "" ? this.userForm.avatar = imgArr.static : this.userForm.avatar = this.userForm.avatar;

        this.deptsOptions.forEach(item => { this.userForm.deptNames.push(item.label) });
        this.typeOptions.forEach(item => {
          if (data.data.type == item.value) this.userForm.typeName = item.label;
        });
        this.titlesOptions.forEach(item => {
          if (this.doctorForm.titleId == item.value) this.doctorForm.titleName = item.label;
        });
        this.userEditForm = JSON.parse(JSON.stringify(this.userForm));
        this.doctorEditForm = JSON.parse(JSON.stringify(this.doctorForm));
      }
      this.loading = false;
    },
    // 请求称号列表
    async getTitlesData() {
      let { code, rows, total } = await titleList();
      if (code == 200 && total > 0) {
        rows.forEach(item => { this.titlesOptions.push({ label: item.titleName, value: item.titleId }) });
        this.getUserInfo(); // 初始化获取用户信息
      }
    },
    // 修改资料
    userEdit() {
      this.dialogVisible = true;
    },
    // 保存修改
    editSave() {
      let formArr, resultArr = [], _this = this;
      if (this.userForm.type == 0) formArr = ['userEditForm', 'doctorEditForm'];
      else formArr = ['userEditForm'];
      function checkForm(formName) {
        let result = new Promise(function (resolve, reject) {
          _this.$refs[formName].validate((valid) => {
            if (valid) resolve();
            else reject();
          })
        });
        resultArr.push(result)
      }
      formArr.forEach(item => { checkForm(item) })
      Promise.all(resultArr).then(function () {
        let params = JSON.parse(JSON.stringify(_this.userEditForm));
        if (params.type == 0) params.hospDoctorInfo = _this.doctorEditForm;
        userEdit(params).then(res => {
          if (res.code == 200) _this.$message.success("基础信息修改成功，如需修改其他信息，请联系管理员！");
          _this.loading = true;
          _this.getUserInfo();
          _this.dialogVisible = false;
          _this.$session.set('user', params);
          location.reload();
          formArr.forEach(item => { _this.$refs[item].resetFields() });
        })
      }).catch(function () {
        console.log("err");
      });
    },
    // 刷新
    // refresh() {
    //   this.loading = true;
    //   this.getUserInfo();
    // },
    // 图片上传成功的函数
    handleImgSuccess1(res) {
      let { code, msg } = res;
      if (code === 200) this.doctorEditForm.doctorImgAddr = msg;
    },
    handleImgSuccess2(res) {
      let { code, msg } = res;
      if (code === 200) this.userEditForm.avatar = msg;
    },
    // 清除图片地址，显示上传图片
    editImg(img) {
      if (img == 'avatar') this.userEditForm.avatar = null;
      if (img == 'doctorImgAddr') this.doctorEditForm.doctorImgAddr = null;
    },
    // 取消
    cancel() {
      this.userEditForm = JSON.parse(JSON.stringify(this.userForm));
      this.doctorEditForm = JSON.parse(JSON.stringify(this.doctorForm));
      this.dialogVisible = false;
    }
  },
};
</script>

<style lang="less" scoped>
.personal-warp{
  height: 100%;
  // overflow: auto;
}
.el-card {
  height: 100%;

  /deep/.el-card__body {
    overflow-y: scroll;

    .userwrap {

      /* 用户信息 */
      .userinfo {
        position: relative;
        font-size: 14px;

        p {
          line-height: 20px;
        }

        .el-row {
          line-height: 34px;
          display: flex;
          align-items: center;

          .el-tag {
            margin: 4px 10px 4px 0;
          }

          span:first-of-type {
            width: 80px;
          }

          div {
            flex: 1;
          }
        }

        &>img {
          border-radius: 50px;
          border: 1px solid #ccc;
          position: absolute;
          right: 0;
          top: 0;
        }

        .el-button {
          margin-top: 20px;
        }
      }

      /* 用户模态框 */
      .userEdit {
        .el-form-item:not(:last-child) {
          width: 48%;
        }

        .el-input,
        .el-textarea {
          width: 240px;
        }
      }

      .img {
        max-width: 200px;
        border: 1px solid #ddd;
        height: auto;
        display: block;
      }

      .btn {
        margin-top: 5px;
      }
    }
  }
}
</style>